import React, { useEffect, useState } from 'react'
import Stories from './Stories'
import { makeStyles } from '@material-ui/core'
import api from '../exhibitApi'


const useStyles = makeStyles(theme => {
  return {
    search: {
      marginTop: 15,
      color: theme.palette.primary.main,
      fontSize: 18,
      boxSizing: 'border-box'
    }
  }
})

export default function SearchPage(props){
  const { searchValue, showStory, appId, toggleProgressDialog, performSearch } = props
  const classes = useStyles()

  const [stories, setStories] = useState([])


  useEffect(() => {
    async function search(appId, term){
      const newStories = await api.story().search({ appId, term })
      setStories(newStories)
      toggleProgressDialog()
    }

    async function searchTags(tag){
      const newStories = await api.story().searchTags({ appId, tag })
      setStories(newStories)
      toggleProgressDialog()
    }

    if(!performSearch) return

    if(searchValue === ''){
      setStories([])
    }else if(searchValue.charAt(0) === '#'){
      const value = searchValue.substring(1)
      searchTags(appId, value)
    }else{
      search(appId, searchValue)
    }

  }, [appId, api, searchValue, performSearch])


  return (
    <>
    <div className={classes.search}>Search: {searchValue}</div>
    <Stories stories={stories} showStory={showStory} />

    </>
  )
}
